import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function ConfirmButton({
    onConfirm, title = "Are you sure?", description = "", confirmLabel = "Confirm",
    children, testId, confirmTestId, ...props
}) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button data-testid={testId} onClick={() => setOpen(true)} {...props}>{children}</Button>
            <AlertDialog open={open} onOpenChange={setOpen}>
                <AlertDialogContent className="bg-card border-border">
                    <AlertDialogHeader>
                        <AlertDialogTitle className="font-heading uppercase text-foreground">{title}</AlertDialogTitle>
                        <AlertDialogDescription>{description}</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel data-testid="confirm-cancel">Cancel</AlertDialogCancel>
                        <AlertDialogAction
                            data-testid={confirmTestId || "confirm-ok"}
                            className="bg-danger text-white hover:bg-danger/90"
                            onClick={() => { setOpen(false); onConfirm(); }}>
                            {confirmLabel}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
}
